import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { SortOrder } from '../../../../models/common.enums';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'th[appTh]',
  templateUrl: './data-table-header-cell.component.html',
  styleUrls: ['./data-table-header-cell.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableHeaderCellComponent implements OnInit {
  readonly sortOrder = SortOrder;

  // @Input() hasSort = false;
  @Input() sorted = false;
  @Input() order: SortOrder | null;

  // @Output() sort = new EventEmitter<SortOrder | null>();

  @HostBinding('class.data-table__header-cell') class = true;
  // @HostBinding('class.data-table__header-cell_sorting') withSorting = false;

  // @HostListener('click', ['$event'])
  // onClick(_: MouseEvent): void {
  //   if (this.hasSort) {
  //     this.toggleColumnSort();
  //   }
  // }

  constructor() {
  }

  ngOnInit(): void {
    // this.withSorting = this.hasSort;
  }

  // toggleColumnSort(): void {
  //   this.order = !this.order ? SortOrder.Asc : this.order === SortOrder.Asc ? SortOrder.Desc : null;
  //   this.sorted = !!this.order;
  //
  //   this.sort.emit(this.order);
  // }

}
